import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { debounce } from "lodash";
import axios from "axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'ServerSideAddressInputWidget',
  props: {
    value: null,
    placeholder: null
  },
  emits: [
  'update:modelValue'
],
  setup(__props: any, { emit }) {

const props = __props as {
  value?: any,
  placeholder?: string
};





function doRequest(address) {
  return axios
    .get(
      '/web-api/addresses/geocode', {
        params: {
          q: address
        }
      }
    )
    .then((response) => {
      console.debug(response);

      return response.data.data;
    })
    .catch((error) => {
      console.error(error);
    });
}

let typedAddress = ref('');
let selectedAddressItem = ref<any>(null);
let isBusy = ref(false);

let suggestionResults = ref<{
  label: string
  value: string
}[]>([]);

const handleAddressInput = debounce(() => {
  if (typedAddress.value.length < 3)
    return;

  isBusy.value = true;
  selectedAddressItem.value = null;

  doRequest(typedAddress.value)
    .then((data) => {
      suggestionResults.value = data;
    })
    .finally(() => {
      isBusy.value = false;
    });
}, 800);

function handleSuggestedItemClick(item: any) {
  console.debug(item);

  selectedAddressItem.value = item;

  emit('update:modelValue', item);
}

return { __sfc: true,emit, props, doRequest, typedAddress, selectedAddressItem, isBusy, suggestionResults, handleAddressInput, handleSuggestedItemClick }
}

})